import {Component, Input, OnInit} from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import {AuthService} from '../../services/auth.service';
import * as global from "../../includes/global"

@Component({
    selector: 'app-appointment',
    templateUrl: './appointment.template.html',
    providers: []
})
export class AppointmentComponent implements OnInit {
    global = global;
  @Input() patient;
    currentUser: any;
   isUserAppointment :boolean = false;
    constructor(private _authService: AuthService,
        private route: ActivatedRoute,
        private toaster: ToastrService,
        private router: Router,) {
    this.currentUser = this._authService.currentUser;

    }

    ngOnInit(): void {
        if(this.currentUser.user_type == global.USER_TYPE.DOCTOR ){
            this.isUserAppointment = true;            
        }
    }
}
